import React from 'react';
import Icon from '../../../components/AppIcon';

const SafetyFeatures = ({ features }) => {
  return (
    <div className="bg-gradient-journey text-white rounded-xl p-6 md:p-8 lg:p-10">
      <div className="max-w-4xl mx-auto space-y-6 md:space-y-8">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/10 backdrop-blur-sm mb-4">
            <Icon name="Shield" size={32} className="text-accent" />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold">
            Your Safety is Our Priority
          </h2>
          <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto">
            We maintain the highest safety standards with verified drivers, well-maintained vehicles, and 24/7 support
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 space-y-3 hover:bg-white/20 transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-white/10 flex items-center justify-center">
                <Icon name={feature?.icon} size={24} className="text-accent" />
              </div>
              <h3 className="text-base md:text-lg font-semibold">{feature?.title}</h3>
              <p className="text-sm text-white/80 leading-relaxed">{feature?.description}</p>
            </div>
          ))}
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <Icon name="Award" size={20} className="text-accent" />
            <span className="text-sm font-medium">ISO Certified</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <Icon name="Star" size={20} className="text-accent" />
            <span className="text-sm font-medium">4.8 Safety Rating</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <Icon name="Users" size={20} className="text-accent" />
            <span className="text-sm font-medium">50,000+ Happy Customers</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyFeatures;